/**
 * ADR-0235 — may this user file "This is wrong" on a trust label? Owner,
 * admin or reviewer, and never inside a support session. One rule for the
 * Agents page and the visits panel.
 */

import { useOptionalAuth } from '../../../app/auth-context.js';

export function useCanDisputeTrust(): boolean {
  const auth = useOptionalAuth();
  if (auth === null || auth.state.kind !== 'authenticated') return false;
  const user = auth.state.user;
  return user.support_session == null
    && (user.role === 'owner' || user.role === 'admin' || user.role === 'reviewer');
}
